import { render, staticRenderFns } from "./PoolsPage.vue?vue&type=template&id=39c52d66"
import script from "./PoolsPage.vue?vue&type=script&lang=js"
export * from "./PoolsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports